import { FeatureLaunch, isFeatureLaunched } from '@commenda/feature-launches';
import { Badge, Tooltip } from '@commenda/kakashi';

export const SenderFirmBadge = ({ firmName }: { firmName?: string | null }) => {
  if (!firmName || !isFeatureLaunched(FeatureLaunch.THREAD_FIRM_NAME_BADGE)) {
    return null;
  }

  return (
    <Tooltip content={firmName}>
      <Badge
        variant="gray"
        size="sm"
        className="max-w-40 min-w-0 overflow-hidden [&>span]:truncate [&>span]:min-w-0"
      >
        {firmName}
      </Badge>
    </Tooltip>
  );
};
